/**
 * Created by Jie Gao on 2021-02-24.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GGParsedInitData} from "../server/data/GGParsedInitData";
import {GGParsedGameData} from "../server/data/GGParsedGameData";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {AvalancheReelEvent} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheReelEvent";
import {GGReelSymbolZ} from "../symbols/GGReelSymbolZ";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GGReelSymbolName} from "../symbols/GGReelSymbolName";
import {GGGameModuleConfig} from "../GGGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class DeadWildAttention extends BaseView {

    private _dwSymbols:StateReelSymbol[] = [];
    private _dwCounter:number = 0;
    private _isNextAvalanch:boolean;
    private _hasTransform:boolean;
    private _isRestore:boolean = false;
    private _reels:string[][];

    constructor() {
        super();
    }

    public get allDeadWilds(): StateReelSymbol[] {
        return this._dwSymbols;
    }

    protected initAnimations():void {
        this._dwCounter = 0;
        this._dwSymbols = [];
    }

    protected onResize(resizeData:IResizeData):void {}

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, AvalancheReelEvent.REEL_STOP_SPIN_SYMBOL_ATTENTION_START, (event:GameEvent) => this.onReelStopSymbolAttention(event.params[0]));
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_ANIMATION_STOPPED, (event:GameEvent) => this.onAllReelsLanded());
    }

    private onInitGameDataParsed(data:GGParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._isNextAvalanch = data.nextMode.indexOf("_AVALANCHE")>-1;
        this._reels = data.reelsAfterCollapse;
    }

    private onGameDataParsed(data:GGParsedGameData):void {
        this._isNextAvalanch = data.isNextAvalancheMode;
        this._hasTransform = !(data.dwTransform == null);
    }

    private onReelStopSymbolAttention(data:IReelStoppedData):void {
        const symbol:StateReelSymbol = data.symbols![0];
        if(symbol.symName === GGReelSymbolName.DEADWILD) {
            this._dwCounter++;
            this._dwSymbols.push(symbol);
            if(this._dwCounter === 1) {
                (<GGReelSymbolZ>symbol).playLandingAnimation();
            } else if(this._dwCounter >1) {
                this._dwSymbols.forEach((symbol:StateReelSymbol) => {
                    (<GGReelSymbolZ>symbol).playGlowAnimation();
                });
            }
            GGGameModuleConfig.soundPlayer.playDeadWildLandingSound(this._dwCounter);
        }
    }

    private onAllReelsLanded():void {
        if(!this._isNextAvalanch || this._hasTransform) {
            this._dwCounter = 0;
            this._dwSymbols.forEach((symbol:StateReelSymbol) => {
                (<GGReelSymbolZ>symbol).stopLandingAnimation();
            });
            this._dwSymbols = [];
        }
    }

    private onRestore():void {
        if(!(this._isRestore && this._isNextAvalanch)){
            return;
        }
        this._reels.forEach((syms:string[],i:number)=>{
            syms.forEach((sym:string, j:number)=>{
                if(sym === GGReelSymbolName.DEADWILD) {
                    const symbol:StateReelSymbol = Reels.getSymbol(i, j)!;
                    this._dwCounter++;
                    this._dwSymbols.push(symbol);
                }
            });
        });
        if(this._dwCounter<2){
            return;
        }
        this._dwSymbols.forEach((symbol:StateReelSymbol) => {
            (<GGReelSymbolZ>symbol).playGlowAnimation();
        });
    }
}